import React, { Component } from 'react';
import './styles.css';

class Header extends Component {
	render() {
		return (
			<div className="submission-pop-up-layout-header">
				{this.props.children}
			</div>
		);
	}
}

export default Header;
